import humanizeString from 'humanize-string'
import React, { FC } from 'react'

import { AccountStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

interface ListingAccountStatusFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const ListingAccountStatusFilter: FC<ListingAccountStatusFilterProps> = props => {
  const accountStatusOptions = Object.values(AccountStatus).map(accountStatus => ({
    value: accountStatus,
    hasFullWidth: true,
    label: humanizeString(accountStatus),
  }))

  return <CheckboxBasedFilter title="Account Status" options={accountStatusOptions} {...props} />
}
